import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  changePasswordRequest: ['history'],
  changePasswordSuccess: null,
  changePasswordFailure: ['error'],
  currentPasswordChanged: ['currentPassword'],
  newPasswordChanged: ['newPassword'],
});

export const ChangePasswordTypes = Types;
export default Creators;



// WEBPACK FOOTER //
// ./src/state/actions/ChangePasswordActions.js